"use client";
import * as React from "react";
import { alpha } from "@mui/material/styles";
import { StyledEngineProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import AppNavbar from "./components/AppNavBar";
import SideMenu from "./components/SideMenu";
import AppTheme from "./components/theme/AppTheme";
import Header from "./components/Header";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from "./components/theme/customizations";
import MainGrid from "./components/MainGrid";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: "16px",
        fontSize: "0.875rem",
      },
      head: {
        fontWeight: 600,
        backgroundColor: "var(--joy-palette-background-level1)",
      },
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        "& .MuiTableRow-root": {
          backgroundColor: "var(--joy-palette-background-level1)",
        },
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: "none",
      },
    },
  },
};

export default function AdminLayout({ children }) {
  return (
    <StyledEngineProvider injectFirst>
      <AppTheme themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: "flex" }}>
          <SideMenu />
          <AppNavbar />
          {/* Main content */}
          <Box
            component="main"
            sx={theme => ({
              flexGrow: 1,
              backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
              overflow: "auto",
              minHeight: "100vh",
            })}
          >
            <Stack
              spacing={2}
              sx={{
                alignItems: "center",
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
              }}
            >
              <Header />
              {children}
            </Stack>
          </Box>
        </Box>
      </AppTheme>
    </StyledEngineProvider>
  );
}
